(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tt-product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tt-product-description')) {
    customElements.define('tt-product-description', class extends HTMLElement {
      connectedCallback() {
        this.full = this.querySelector('.tt-product-description__full');
        this.preview = this.querySelector('.tt-product-description__preview');
        this.text = this.querySelector('[data-description-preview]');
        this.ellipsis = this.querySelector('[data-description-ellipsis]');
        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-description-label]');
        this.expanded = this.expanded || false;
        this.events = new AbortController();
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.motionPreference.addEventListener('change', () => {
          if (this.motionPreference.matches) this.stopAnimation();
        }, { signal: this.events.signal });
        this.button.addEventListener('click', () => this.toggle(), { signal: this.events.signal });
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.measure());
        };
        this.observer = new ResizeObserver(([entry]) => {
          const styles = getComputedStyle(this);
          const typography = [styles.fontSize, styles.lineHeight, styles.fontFamily, styles.letterSpacing].join('|');
          if (entry.contentRect.width !== this.width || typography !== this.typography) {
            this.width = entry.contentRect.width;
            this.typography = typography;
            this.schedule();
          }
        });
        this.observer.observe(this);
        window.addEventListener('resize', this.schedule, { signal: this.events.signal });
        document.fonts.ready.then(() => {
          if (this.isConnected) this.schedule();
        });
        this.schedule();
      }

      disconnectedCallback() {
        this.events.abort();
        this.observer.disconnect();
        cancelAnimationFrame(this.frame);
        this.stopAnimation();
      }

      stopAnimation() {
        this.animation?.cancel();
        this.animation = null;
        this.removeAttribute('data-animating');
      }

      toggle() {
        const fromHeight = this.getBoundingClientRect().height;
        this.stopAnimation();
        this.expanded = !this.expanded;
        this.render();
        const toHeight = this.getBoundingClientRect().height;
        if (this.motionPreference.matches || Math.abs(toHeight - fromHeight) < 1) return;
        this.setAttribute('data-animating', '');
        this.animation = this.animate(
          [{ height: `${fromHeight}px` }, { height: `${toHeight}px` }],
          { duration: 200, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' }
        );
        this.animation.onfinish = () => this.stopAnimation();
      }

      measure() {
        if (!this.getBoundingClientRect().width) return;
        this.stopAnimation();
        this.full.hidden = false;
        this.preview.hidden = true;
        const styles = getComputedStyle(this);
        const lineHeight = parseFloat(styles.lineHeight) || parseFloat(styles.fontSize) * 1.5;
        const limit = lineHeight * 3 + 1;
        this.canCollapse = this.full.getBoundingClientRect().height > limit;
        if (!this.canCollapse) {
          this.render();
          return;
        }
        const words = this.full.innerText.trim().split(/\s+/);
        this.full.hidden = true;
        this.preview.hidden = false;
        this.text.hidden = false;
        this.ellipsis.hidden = false;
        this.label.textContent = this.dataset.more;
        this.button.setAttribute('aria-expanded', 'false');
        let low = 0;
        let high = words.length;
        while (low < high) {
          const middle = Math.ceil((low + high) / 2);
          this.text.textContent = words.slice(0, middle).join(' ');
          if (this.preview.getBoundingClientRect().height <= limit) low = middle;
          else high = middle - 1;
        }
        this.text.textContent = words.slice(0, low).join(' ');
        this.render();
      }

      render() {
        this.full.hidden = this.canCollapse && !this.expanded;
        this.preview.hidden = !this.canCollapse;
        this.text.hidden = this.expanded;
        this.ellipsis.hidden = this.expanded;
        this.label.textContent = this.expanded ? this.dataset.less : this.dataset.more;
        this.button.setAttribute('aria-expanded', String(this.expanded));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tt-technical-documents"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('.tt-technical-documents-jump');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    const start = window.scrollY;
    const offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 140;
    const end = Math.max(0, Math.min(start + target.getBoundingClientRect().top - offset, document.documentElement.scrollHeight - window.innerHeight));
    history.replaceState(null, '', link.hash);
    target.focus({ preventScroll: true });
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo({ top: end, behavior: 'instant' });
      return;
    }
    const began = performance.now();
    function frame(now) {
      const progress = Math.min((now - began) / 320, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      window.scrollTo({ top: start + (end - start) * eased, behavior: 'instant' });
      if (progress < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  });
  } catch(e) { console.error(e); }
})();

})();
